import React from "react";
import { wordwrap } from "d3-jetpack";
import { group, sum } from "d3-array";
import { scaleLinear } from "d3-scale";

const RemittanceGrowthRate = ({ props }) => {
  const width = 350;
  const height = 300;

  const margin = {
    top: 50,
    right: 20,
    bottom: 50,
    left: 70,
  };

  const l = scaleLinear().domain([-15, 0, 15]).range([-20, 0, 20]);

  const years = ["2017", "2018", "2019", "2020e", "2021f", "2022f"];

  const data = props.data["remittance-growth-rate"].map((d) => ({
    ...d,
    values: years.reduce((acc, cur, i) => {
      const previous = i === 0 ? { x1: 0, y1: 0 } : acc[i - 1];
      const value = d[cur];

      const pos = value >= 0;

      const x = 4 * value * (pos ? 1 : -1) * Math.cos(-Math.PI / 4);
      const y = 4 * value * (pos ? 1 : 1) * Math.sin(-Math.PI / 4);

      acc.push({
        x0: previous.x1,
        y0: previous.y1,
        x1: previous.x1 + x,
        y1: previous.y1 + y,
        x: x,
        y: y,
        year: cur,
        value: d[cur],
      });

      return acc;
    }, []),
  }));

  const labelTweaks = [
    {
      2019: { textAnchor: "middle", dy: -4, dx: 0 },
      "2020e": { textAnchor: "middle", dy: 13, dx: 0 },
      "2021f": { textAnchor: "start", dy: 6, dx: 7 },
      "2022f": { textAnchor: "start", dy: 0, dx: 3 },
    },
    {
      "2020e": { textAnchor: "start", dy: -4, dx: 4 },
    },
    {},
    {
      "2022f": { textAnchor: "start", dy: 6, dx: 4 },
      "2021f": { textAnchor: "end", dy: 4, dx: -10 },
      "2020e": { textAnchor: "start", dy: 10, dx: 4 },
      2018: { textAnchor: "start", dy: 10, dx: 4 },
      2017: { textAnchor: "end", dy: 6, dx: -12 },
      2019: { textAnchor: "end", dy: 4, dx: -10 },
    },
    { "2020e": { textAnchor: "end", dy: 2, dx: -8 } },
    {
      2018: { textAnchor: "end", dy: 4, dx: -10 },
      "2020e": { textAnchor: "middle", dy: 13, dx: 0 },
      "2021f": { textAnchor: "start", dy: 8, dx: 6 },
      "2022f": { textAnchor: "start", dy: 0, dx: 4 },
    },
  ];

  const w = width - margin.right - margin.left;
  const h = height - margin.top - margin.bottom;

  return (
    <div className="remittance-growth-rate" style={{ textAlign: "center" }}>
      {data.map((d, i) => (
        <svg
          width={width}
          height={height}
          viewBox={`0 0 ${width} ${height}`}
          style={{ display: "inline" }}
          key={`chart-${i}`}
        >
          <defs>
            <marker
              id="triangle-red"
              viewBox="0 0 10 10"
              refX="8"
              refY="5"
              markerUnits="strokeWidth"
              markerWidth="3"
              markerHeight="3"
              orient="auto"
            >
              <path d="M 0 0 L 10 5 L 0 10 z" fill="darkred" />
            </marker>
            <marker
              id="triangle-blue"
              viewBox="0 0 10 10"
              refX="8"
              refY="5"
              markerUnits="strokeWidth"
              markerWidth="3"
              markerHeight="3"
              orient="auto"
            >
              <path d="M 0 0 L 10 5 L 0 10 z" fill="steelblue" />
            </marker>
          </defs>
          <g transform={`translate(${margin.left}, ${margin.top})`}>
            <g transform={`translate(0, ${h - 40})`}>
              <line x2={w} stroke="#999" />
              {d.values.map((d, j) => (
                <g key={`item-${j}`}>
                  <line
                    x1={d.x0}
                    y1={d.y0}
                    x2={d.x1}
                    y2={d.y1}
                    stroke={d.value >= 0 ? "steelblue" : "darkred"}
                    style={{
                      strokeWidth: 3,
                      strokeLinecap: "butt",
                      markerEnd:
                        d.value >= 0
                          ? "url(#triangle-blue)"
                          : "url(#triangle-red)",
                    }}
                  />
                  <text
                    x={d.x1}
                    y={d.y1}
                    fill={d.value >= 0 ? "steelblue" : "darkred"}
                    dx={
                      labelTweaks[i][d.year]
                        ? labelTweaks[i][d.year].dx
                        : d.value >= 0
                        ? -6
                        : 4
                    }
                    dy={labelTweaks[i][d.year] ? labelTweaks[i][d.year].dy : 0}
                    style={{
                      fontSize: 12,
                      textAnchor: labelTweaks[i][d.year]
                        ? labelTweaks[i][d.year].textAnchor
                        : d.value >= 0
                        ? "end"
                        : "start",
                    }}
                  >
                    {/* <text
                    x={d.x1}
                    y={d.y1}
                    dx={
                      i === 3 && d.year === "2017" ? -20 : d.value >= 0 ? -5 : 5
                    }
                    dy={
                      i === 3 && d.year === "2017"
                        ? 15
                        : d.year === "2019"
                        ? -10
                        : 0
                    }
                    fill={d.value >= 0 ? "steelblue" : "darkred"}
                    style={{
                      fontSize: 12,
                      textAnchor:
                        d.year === "2019"
                          ? "middle"
                          : d.value >= 0
                          ? "end"
                          : "start",
                    }}
                  > */}
                    <tspan style={{ fontWeight: "bold" }}>{d.value}%</tspan>{" "}
                    <tspan>{d.year}</tspan>
                  </text>
                </g>
              ))}
              <text
                style={{
                  fontWeight: "bold",
                  textAnchor: "middle",
                  fontSize: 14,
                }}
              >
                {wordwrap(
                  props.data.regions.find((p) => p.code === d.region).label,
                  15
                ).map((d, i) => (
                  <tspan x={w / 2} y={20 + i * 14} key={`token-${i}`}>
                    {d}
                  </tspan>
                ))}
              </text>
            </g>
            <g>
              <g key={`region-${i}`}>
                <g>
                  <text
                    y={-20}
                    style={{
                      fontSize: 12,
                      textAnchor: "middle",
                      fontWeight: "bold",
                    }}
                  ></text>
                </g>
              </g>
            </g>
          </g>
        </svg>
      ))}
    </div>
  );
};

export default RemittanceGrowthRate;
